// Der Vertrieb (Betriebe, Briefe, Ablauf, Analyse) ist am 13.10.2026 nach Publivo umgezogen
// (Nico: „Es soll komplett nur noch in Publivo das Ganze stattfinden“). Hier nur noch der Hinweis.
import { ExternalLink } from 'lucide-react';

const ZIEL = 'https://dashboard.publivo.app/admin/vertrieb';

export default function VertriebUmgezogen() {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h1 className="text-xl font-semibold text-gray-900">Der Vertrieb ist nach Publivo umgezogen</h1>
      <p className="mt-2 text-sm text-gray-600">
        Betriebe, Briefe, Anrufe, Ablauf und Analyse laufen seit dem 13.10.2026 nur noch in Publivo.
        Alle Daten aus dem LMS sind dort übernommen.
      </p>
      <a
        href={ZIEL}
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-gray-800"
      >
        Vertrieb in Publivo öffnen <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  );
}
